export default __webpack_public_path__ + "static/media/3.25add3e9.jpg";